import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: 100,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      overFlow: 'hidden'
    },
    container: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      marginLeft: 'auto',
      marginRight: 'auto',
      animation: `$apparition 800ms ease-in-out`,
      overflowX: 'hidden',
      maxHeight: '98vh',
      overFlowY: 'scroll',
      '@media (max-width: 768px)': {
        width: '90%'
      }
    },
    '@keyframes apparition': {
      '0%': {
        top: '200vh'
      },
      '80%': {
        top: '40%'
      },
      '100%': {
        top: '50%'
      }
    },
    modalHead: {
      position: 'absolute',
      top: '15px',
      left: '50%',
      transform: 'translate(-50%, 0)',
      marginLeft: 'auto',
      marginRight: 'auto',
      whiteSpace: 'nowrap'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
